<template>
  <full-height-panel container-width="1000">
    <template #header>
      <div class="flex items-center">
        <vs-button :to="{name: 'uc_b_fines_recalculations'}" type="border" icon="keyboard_backspace" tag="a">
          Назад
        </vs-button>
        <h2 class="ml-4">
          {{ isEdit ? 'Изменить перерасчет пеней' : 'Добавить перерасчет пеней' }}
        </h2>
        <vs-button class="ml-auto" icon="delete_outline" @click="onRemoveAll">Удалить все</vs-button>
      </div>
    </template>

    <div :class="$style.container">
      <div :class="$style.form">
        <div :class="$style.row">
          <div :class="$style.left">
            <elsa-v-datepicker
              label="В какую квитанцию попадет перерасчет?"
              view-format="LLLL yyyy"
              :datepicker-props="{minimumView: 'month'}"
              v-model="data.month"
              :danger="!!errors.month"
              :danger-text="errors.month"
              :disabled="isEdit"
            />
          </div>
          <div :class="$style.right">
            <div :class="$style.account">
              <elsa-v-select
                html-label="№ Лицевого счета"
                v-model="data.account_number"
                :options="apartments || []"
                :loading="!apartments"
                :danger="!!errors.account_number"
                :danger-text="errors.account_number"
                :disabled="isEdit"
              />
            </div>
          </div>
        </div>
        <div :class="$style.row">
          <div :class="$style.left">
            <vs-input
              class="w-full"
              label="Общая сумма перерасчета"
              v-model="data.sum"
              v-currency
              :danger="!!errors.sum"
              :danger-text="errors.sum"
            />
            <div :class="$style.total">
              Распределено: {{ spendedSum }}
              <br />
              Осталось распределить: {{ remainSum }}
            </div>
          </div>
          <div :class="$style.right">
            <app-textarea
              label="Основание (отобразится в квитанции)"
              v-model="data.comment"
              :danger="!!errors.comment"
              :danger-text="errors.comment"
            />
          </div>
        </div>
        <div :class="$style.row">
          <div :class="$style.left">
            <vs-checkbox v-model="data.force">
              Создать перерасчет, даже если квитанция уже показана в ЛК
            </vs-checkbox>
          </div>
          <div :class="$style.right">
            <app-textarea
              label="Комментарий"
              v-model="data.accountant_comment"
              :danger="!!errors.accountant_comment"
              :danger-text="errors.accountant_comment"
            />
          </div>
        </div>
      </div>

      <div :class="$style.list">
        <h4 class="mb-4">Пени:</h4>

        <div :key="i" v-for="(item, i) in data.parameters" :class="$style.item" ref="parameters">
          <div :class="$style.removeButton">
            <vs-button
              iconPack="feather"
              icon="icon-trash"
              type="border"
              title="Удалить"
              @click="onRemoveRow(i)"
            />
          </div>

          <div :class="$style.index">{{ i + 1 }}</div>

          <div :class="$style.month">
            <elsa-v-datepicker
              label="Месяц с некорректной пеней"
              view-format="LLLL yyyy"
              v-model="item.month"
              :datepicker-props="{minimumView: 'month'}"
              :danger="!!errors[`parameters.${i}.month`]"
              :danger-text="errors[`parameters.${i}.month`]"
            />
          </div>

          <div :class="$style.sum">
            <vs-input
              class="w-full"
              label="Сумма перерасчета"
              v-model="item.sum"
              v-currency
              :danger="!!errors[`parameters.${i}.sum`]"
              :danger-text="errors[`parameters.${i}.sum`]"
              @keydown="onInputKeydown($event, i)"
            />
          </div>

        </div>

        <vs-button
          :class="$style.addButton"
          size="large"
          icon="add"
          color="#fff"
          @click="onAddRow"
          :disabled="loading"
        >
          Добавить строку
        </vs-button>

        <div v-if="errors.parameters" :class="$style.error">{{ errors.parameters }}</div>
      </div>
    </div>

    <template #footer>
      <div :class="$style.footer">
        <!--        <div v-if="errorsCount" :class="$style.errors">Ошибок: {{ errorsCount }}</div>-->
        <vs-button
          id="fines-recalculation-button"
          color="success"
          @click="onSubmit"
        >
          {{ isEdit ? 'Сохранить перерасчёт' : 'Создать перерасчёт' }}
        </vs-button>
      </div>
    </template>
  </full-height-panel>
</template>

<script>
import FullHeightPanel       from "@/components/FullHeightPanel";
import notifyHttpError       from "@/mixins/notifyHttpError";
import currency              from 'currency.js';
import mergeCommonErrors     from "@/helpers/mergeCommonErrors";
import formatDateToYearMonth from "@/globalFilters/formatDateToYearMonth";
import stringify             from "qs/lib/stringify";

const TAB_KEY = 9;
const ENTER_KEY = 13;

const isModifiedEvent = ( e ) => e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;
const isNextFieldEvent = ( e ) => !isModifiedEvent(e) && (e.keyCode === TAB_KEY || e.keyCode === ENTER_KEY);

const initialData = {
  month:              null,
  account_number:     null,
  sum:                '',
  comment:            '',
  accountant_comment: '',
  force:              false,
  parameters:         [],
};

export default {
  name:       "FinesRecalculationsAdd",
  components: { FullHeightPanel },
  mixins:     [notifyHttpError],
  data() {

    return {
      data:          { ...initialData, parameters: [{ month: null, sum: '' }] },
      errors:        {},
      loading:       false,
      apartments:    null,
      recalculation: null,
      lastMonth:     null,
    };
  },
  computed: {
    selectedBuildingId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    spendedSum() {
      return this.data.parameters.reduce(( total, param ) => {
        return total.add(param.sum);
      }, currency(0)).toString();
    },
    remainSum() {
      return currency(this.data.sum).subtract(this.spendedSum).toString();
    },
    recalculationId() {
      const { params } = this.$route;
      if (!params) return null;
      return +params.id || null;
    },
    isEdit() {
      return !!this.recalculationId;
    },
  },
  methods:  {
    updateLoading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#fines-recalculation-button',
          scale:     .5,
        });

      } else {
        this.$vs.loading.close('#fines-recalculation-button > .con-vs-loading');
      }
    },

    loadAccounts() {
      this.$http.get(`/buildings/${this.selectedBuildingId}/account_numbers`, { params: { buildings_id: this.selectedBuildingId } }).then(
        ( { data } ) => {
          this.apartments = data.map(apartment => ({
            label:    apartment.account_number,
            value:    apartment.account_number,
            original: apartment,
          }));
          if (this.isEdit) {
            this.data.account_number = this.apartments.find(a => a.value === this.recalculation.account_number);
          }
        },
        this.notifyHttpError,
      );
    },

    loadRecalculation() {
      return this.$http.get(`/fines/recalculation/${this.recalculationId}`, {
        params:           { buildings_id: this.selectedBuildingId },
        paramsSerializer: ( params ) => stringify(params),
      }).then(( { data } ) => {
        const recalculation = data;
        if (!recalculation) return this.$vs.notify({
          color: 'danger',
          time:  10000,
          title: 'Ошибка',
          text:  'Перерасчет не найден',
        });
        this.recalculation = recalculation;
        this.data = {
          month:              new Date(recalculation.month),
          account_number:     this.apartments ? this.apartments.find(a => a.value === recalculation.account_number) : null,
          sum:                recalculation.sum,
          comment:            recalculation.comment,
          accountant_comment: recalculation.accountant_comment,
          force:              recalculation.force,
          parameters:         recalculation.parameters.map(p => ({
            sum:   p.sum,
            month: new Date(p.month),
          })),
        };
      });
    },

    onInputKeydown( e, rowIndex ) {
      if (isNextFieldEvent(e)) {
        e.preventDefault();
        if (rowIndex + 1 === this.data.parameters.length) this.onAddRow();
        this.$nextTick(() => {
          this.$refs.parameters[rowIndex + 1].querySelector('input').focus();
        });
      }
    },

    onAddRow() {
      this.data.parameters.push({ month: null, sum: '' });
    },

    onRemoveRow( i ) {
      this.data.parameters.splice(i, 1);
    },

    onRemoveAll() {
      this.data.parameters = [];
    },

    onSubmit() {
      if (this.loading) return;

      this.loading = true;
      const data = this.data;

      const request = this.isEdit
        ? this.$http.put(`/fines/recalculation/${this.recalculationId}`, {
          sum:                data.sum,
          comment:            data.comment,
          accountant_comment: data.accountant_comment,
          force:              data.force,
          parameters:         data.parameters.map(p => ({
            sum:   p.sum,
            month: p.month ? formatDateToYearMonth(p.month) : null,
          })),
          buildings_id:       this.selectedBuildingId,
        })
        : this.$http.post(`/fines/recalculation`, {
          account_number:     data.account_number ? data.account_number.value : null,
          sum:                data.sum,
          month:              data.month ? formatDateToYearMonth(data.month) : null,
          comment:            data.comment,
          accountant_comment: data.accountant_comment,
          force:              data.force,
          parameters:         data.parameters.map(p => ({
            sum:   p.sum,
            month: p.month ? formatDateToYearMonth(p.month) : null,
          })),
          buildings_id:       this.selectedBuildingId,
        });

      request.then(
        () => {
          if (!this.isEdit) this.data = { ...initialData, parameters: [] };

          this.$vs.notify({
            color: 'success',
            time:  10000,
            title: 'Успешно',
            text:  this.isEdit ? 'Перерасчет пеней успешно сохранен' : 'Перерасчет пеней успешно создан',
          });
        },
        ( err ) => {
          const { error, message } = err.response.data;
          this.errors = {};
          if (message) {
            this.$vs.notify({
              color: 'danger',
              time:  10000,
              title: 'Ошибка',
              text:  message,
            });
          } else {
            this.errors = mergeCommonErrors(error, Object.keys(error));
          }
        },
      ).finally(() => this.loading = false);
    },
  },
  mounted() {
    this.loadAccounts();
    if (this.isEdit) this.loadRecalculation();
  },
  watch: {
    selectedBuilding() {
      this.loadAccounts();
    },
    loading() {
      this.updateLoading();
    },
  },
};
</script>

<style lang="scss" module>
$breakpoint: 1500px;

.container {
  display: flex;
  align-items: flex-start;
  padding: 30px 0;

  @include max-width($breakpoint) {
    flex-direction: column;
  }
}


.form {
  @include max-width($breakpoint) {
    width: 600px;
  }
}

.row {
  display: flex;
  margin-bottom: 30px;
}

.left {
  width: 250px;
  margin-right: 40px;
}

.right {
  width: 300px;
  @include max-width($breakpoint) {
    width: auto;
    flex: 1;
  }
}

.account {
  margin-top: 15px;
}

.total {
  font-size: 13px;
  margin-top: 10px;
}

.list {
  width: 550px;
  margin-left: 60px;
  border-left: 1px solid #CBCBCB;
  padding-left: 20px;
  @include max-width($breakpoint) {
    margin-left: 0;
    width: 600px;
  }
}

.item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}

.removeButton {
  padding-top: 18px;
}

.index {
  color: #828282;
  font-size: 14px;
  width: 40px;
  flex-shrink: 0;
  padding-top: 27px;
  text-align: center;
}

.month {
  flex: 1;
  padding-right: .5em;
}

.sum {
  flex: 1;
}

.addButton {
  background: #fff;
  width: 100%;
  color: #989898;
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.error {
  margin-top: .5em;
  display: block;
  color: color(danger);
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @include max-width($breakpoint) {
    justify-content: flex-end;
  }
}
</style>
